import React, { useMemo } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Skeleton,
  Typography,
} from "@mui/material";
import ReactApexChart from "react-apexcharts";
import merge from "lodash/merge";
import BaseOptionChart from "../../../components/chart/BaseOptionChart";

const BUCKETS = [
  { key: "bucket_0_15", label: "< 15 min" },
  { key: "bucket_15_30", label: "15-30 min" },
  { key: "bucket_30_60", label: "30-60 min" },
  { key: "bucket_60_240", label: "1-4 h" },
  { key: "bucket_240_plus", label: "> 4 h" },
];

const formatSeconds = (s) => {
  if (!s || s <= 0) return "—";
  const min = Math.floor(s / 60);
  if (min < 60) return `${min} min`;
  const h = Math.floor(min / 60);
  const m = min % 60;
  return m === 0 ? `${h}h` : `${h}h ${m}min`;
};

const AttendanceTimeBuckets = ({ buckets = {}, avgSeconds = 0, loading = false }) => {
  const series = useMemo(
    () => [
      {
        name: "Tickets fechados",
        data: BUCKETS.map((b) => Number(buckets[b.key]) || 0),
      },
    ],
    [buckets]
  );

  const total = series[0].data.reduce((a, b) => a + b, 0);

  const options = useMemo(
    () =>
      merge(BaseOptionChart(), {
        colors: ["#6366f1"],
        chart: { toolbar: { show: false } },
        plotOptions: {
          bar: { horizontal: true, borderRadius: 4, barHeight: "60%" },
        },
        dataLabels: { enabled: true, style: { fontSize: "11px", colors: ["#fff"] } },
        xaxis: {
          categories: BUCKETS.map((b) => b.label),
          labels: { formatter: (v) => Math.round(v) },
        },
        tooltip: {
          y: {
            formatter: (val) => {
              const pct = total > 0 ? ((val / total) * 100).toFixed(1) : 0;
              return `${val} tickets (${pct}%)`;
            },
          },
        },
      }),
    [total]
  );

  return (
    <Card elevation={0} sx={{ border: 1, borderColor: "divider", borderRadius: 2, height: "100%" }}>
      <CardHeader
        title="Tempo de atendimento"
        titleTypographyProps={{ variant: "subtitle1", fontWeight: 600 }}
        subheader={
          total > 0
            ? `${total} fechados · média ${formatSeconds(avgSeconds)}`
            : "Sem tickets fechados com tempo registrado"
        }
        subheaderTypographyProps={{ variant: "caption" }}
      />
      <CardContent sx={{ pt: 0 }}>
        {loading ? (
          <Skeleton variant="rectangular" height={220} />
        ) : total === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center", py: 4 }}>
            Sem dados pra exibir
          </Typography>
        ) : (
          <ReactApexChart options={options} series={series} type="bar" height={240} />
        )}
      </CardContent>
    </Card>
  );
};

export default React.memo(AttendanceTimeBuckets);
